var aprovalFunctions = {
    sendApprovalDates: function () {
        var data = {cartarticles: []};

        $('.data-confirmed-deliverydate').each(function () {
            if (this.value.length > 0) {
                this.id.split()
                data.cartarticles.push({id: this.id.split('_')[3], date: this.value})
            }
        })
        if (data.cartarticles.length > 0) {

            classicInfoMessage(output.t_general_message_save_in_progress);
            var className = 'ajax/Approval/Article/confirmedDeliveryDate';
            AjaxHandlerByClass(className, data, function (result) {
                $(result.ids).each(function(){
                    if(this.id)
                    $('#confirmed_delivery_date_display_' + this.id).html(this.date)
                })
                classicInfoMessage(output.t_general_message_data_saved)
            }, function () {
                classicErrrorMessage(output.t_general_message_save_failed)
            });
        } else {
            classicErrrorMessage(output.t_general_message_no_data);
        }
    }
} 